export let PartnerType;

(function (PartnerType) {
  PartnerType["SalesSolution"] = "SALES_SOLUTION";
  PartnerType["DirectoryUser"] = "DIRECTORY_USER";
})(PartnerType || (PartnerType = {}));